import ApiClient from './ApiClient';

/* global axios */

class DashboardAppsAPI extends ApiClient {
  constructor() {
    super('dashboard_apps', { accountScoped: true });
  }

  getSnapshot(id, conversationId) {
    return axios.get(this.url + '/' + id + '/snapshot', {
      params: { conversation_id: conversationId },
    });
  }

  refreshSnapshot(id, conversationId) {
    return axios.post(this.url + '/' + id + '/snapshot', {
      conversation_id: conversationId,
    });
  }

  unsuppressEmail(id, conversationId) {
    return axios.post(this.url + '/' + id + '/snapshot/unsuppress_email', {
      conversation_id: conversationId,
    });
  }
}

export default new DashboardAppsAPI();
